var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScoreCardResultStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.30161 4.67509C9.57785 4.77902 9.57785 5.23661 9.30161 5.34054C8.50029 5.64206 7.40669 6.13604 6.77179 6.77088C6.13708 7.40573 5.64294 8.49927 5.34156 9.30064C5.23759 9.57687 4.78006 9.57687 4.67609 9.30064C4.37451 8.49927 3.88057 7.40573 3.24566 6.77088C2.61096 6.13604 1.51736 5.64206 0.715994 5.34054C0.439722 5.23661 0.439722 4.77902 0.715994 4.67509C1.51736 4.37356 2.61096 3.87958 3.24566 3.24474C3.88057 2.6099 4.37451 1.51635 4.67609 0.714987C4.78006 0.438753 5.23759 0.438753 5.34156 0.714987C5.64294 1.51635 6.13708 2.6099 6.77179 3.24474C7.40669 3.87958 8.50029 4.37356 9.30161 4.67509Z",
    fill: "#9B5DE5",
    stroke: "#1C1C1E",
    strokeWidth: 1.01686
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScoreCardResultStar);
export default __webpack_public_path__ + "static/media/score-card-result-star.27a31eb5340c09f48d93badbed3a73e7.svg";
export { ForwardRef as ReactComponent };